"use strict";

class SapPostingsController {
    constructor(
        $window,
        $http,
        SSHttpService,
        SSUtilService,
        SSAlertService,
        SSUserService,
        SSConfigService,
        SSConfirmationService,
        OTPService,
        $timeout
    ) {
        const self = this;

        self.$window = $window;
        self.$timeout = $timeout;
        self.$http = $http;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.SSUserService = SSUserService;
        self.SSConfigService = SSConfigService;
        self.SSConfirmationService = SSConfirmationService;
        self.OTPService = OTPService;

        self.data = SHOWSUITE.data;

        let serverConfig = self.SSConfigService.serverConfig;
        self.PAYMENT_TYPES = serverConfig.payment_types;
        if (self.PAYMENT_TYPES && self.PAYMENT_TYPES.length) {
            self.PAYMENT_TYPE_REFUND_NAME = self.PAYMENT_TYPES.find(p => p.id == 20)? self.PAYMENT_TYPES.find(p => p.id == 20).name : null;
        }


        self.SALE_STATUS_ABORTED = SHOWSUITE.SALE_STATUS_ABORTED;
        self.PROPERTY_STATUS_LISTED = SHOWSUITE.PROPERTY_STATUS_LISTED;
        self.PAYMENT_TYPE_20_REFUND = SHOWSUITE.PAYMENT_TYPE_20_REFUND;

        self.LARAVEL_REPORT_SERVER_URL = SHOWSUITE.LARAVEL_REPORT_SERVER_URL;

        self.INSTRUMENT_TYPE_CHEQUE = SHOWSUITE.INSTRUMENT_TYPE_CHEQUE;
        self.INSTRUMENT_TYPE_CASHIERS_ORDER = SHOWSUITE.INSTRUMENT_TYPE_CASHIERS_ORDER;
        self.INSTRUMENT_TYPE_TELEGRAPHIC_TRANSFER = SHOWSUITE.INSTRUMENT_TYPE_TELEGRAPHIC_TRANSFER;
        self.INSTRUMENT_TYPE_CASH_IN = SHOWSUITE.INSTRUMENT_TYPE_CASH_IN;
        self.INSTRUMENT_TYPE_GIRO = SHOWSUITE.INSTRUMENT_TYPE_GIRO;
        self.INSTRUMENT_TYPE_FAST_CASH = SHOWSUITE.INSTRUMENT_TYPE_FAST_CASH;
        self.INSTRUMENT_TYPE_BANK_TRANSFER = SHOWSUITE.INSTRUMENT_TYPE_BANK_TRANSFER;
        self.INSTRUMENT_TYPE_PAYNOW_OTHERS = SHOWSUITE.INSTRUMENT_TYPE_PAYNOW_OTHERS;
        self.INSTRUMENT_TYPE_CASH = SHOWSUITE.INSTRUMENT_TYPE_CASH;

        self.INSTRUMENT_POSTING_STATUS_PENDING = SHOWSUITE.INSTRUMENT_POSTING_STATUS_PENDING; // null
        self.INSTRUMENT_POSTING_STATUS_REVIEWED = SHOWSUITE.INSTRUMENT_POSTING_STATUS_REVIEWED;
        self.INSTRUMENT_POSTING_STATUS_MARKED_FOR_POSTING = SHOWSUITE.INSTRUMENT_POSTING_STATUS_MARKED_FOR_POSTING;
        self.INSTRUMENT_POSTING_STATUS_POSTED = SHOWSUITE.INSTRUMENT_POSTING_STATUS_POSTED;

        self.CATEGORY_PAYMENT = 'payment';
        self.CATEGORY_INSTRUMENT = 'instrument'

        /* WEB-4706: an Interest Waiver has no payment plan clause, so the Payment Type dropdown
         * gets a synthetic option for it (Payments tab only). Its value is a sentinel that
         * _paymentTypeParams() sends as clause_type=20&refund_type=10. */
        self.PAYMENT_REFUND_TYPE_10_WAIVER = SHOWSUITE.PAYMENT_REFUND_TYPE_10_WAIVER;
        self.CLAUSE_TYPE_INTEREST_WAIVER = 'interest_waiver';
        self.interestWaiverOption = { payment_type: self.CLAUSE_TYPE_INTEREST_WAIVER, name: 'Interest Waiver' };

        self.paymentTypes = [
            { id: self.INSTRUMENT_TYPE_CHEQUE, name: "CHEQUE", allowed: true },
            { id: self.INSTRUMENT_TYPE_CASHIERS_ORDER, name: 'CASHIERS\' ORDER', allowed: true },
            { id: self.INSTRUMENT_TYPE_TELEGRAPHIC_TRANSFER, name: 'TT', allowed: true },
            { id: self.INSTRUMENT_TYPE_BANK_TRANSFER, name: "BANK TRANSFER", allowed: true },
            { id: self.INSTRUMENT_TYPE_PAYNOW_OTHERS, name: "PAYNOW", allowed: true },
            { id: self.INSTRUMENT_TYPE_FAST_CASH, name: 'FAST CASH', allowed: true },
            { id: self.INSTRUMENT_TYPE_CASH_IN, name: 'CASH-IN', allowed: true },
            { id: self.INSTRUMENT_TYPE_CASH, name: 'CASH', allowed: true },
            { id: self.INSTRUMENT_TYPE_GIRO, name: 'GIRO', allowed: true },
        ];

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.offset = 0;
        self.limit = 1000;

        self.firstVal = "";
        self.filter = {}; // Filters object
        self.filter.searchFilter = self.CATEGORY_PAYMENT;
        self.filter.date_type = "serving_date";
        self.filter.posting_status = ""+self.INSTRUMENT_POSTING_STATUS_PENDING;
        self.child = [];
        self.clauses = [];
        self._refreshPaymentTypeOptions(); // WEB-4706

        /* WEB-2829 DMS > Select Project drop down
        * Timeout added to make getAllProperties call after getReport call so loading doesn't get hidden */
        self.$timeout(function () {
            self.getAllProperties();
        }, 1200);

        self.posting_date =  null;
    }

    getAllProperties() {
        const self = this;
        let url = "sec/developer/properties/list?status="+self.PROPERTY_STATUS_LISTED;

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.allProperties = response.data.properties;
            self.getPaymentPlans();
            self.$timeout(function () {
                $("select.dashboard-select").niceSelect("update");
                jQuery(".datepicker").datepicker({
                    changeMonth: true,
                    changeYear: true,
                    yearRange: "1900:+0",
                    dateFormat: "yy-mm-dd",
                });
                jQuery('#posting_date').datepicker("destroy"); // Ensure old settings are removed
                jQuery('#posting_date').datepicker({
                    changeMonth: true,
                    changeYear: true,
                    dateFormat: "dd/mm/yy"
                });
            });
            // self.getPostingsData(); // No need to make initial filter call
        });
    }

    /**
     * Fetch the SAP posting listing for the current filters.
     *
     * WEB-4410: a Project is required. Without one the API silently falls back to the
     * developer's first project and, when that project has no default SAP posting
     * configuration, rejects with a generic 412 ("Invalid Params!"). Explicit actions
     * (Apply) tell the user to pick a Project; automatic triggers (Posting Status
     * change, tab switch, Reset) pass `silent` and simply leave the table's
     * "Select Project and click apply" placeholder in place.
     *
     * @param {boolean} [silent=false] Skip the "select a Project" alert when no Project is selected.
     * @returns {boolean|undefined} false when the request was not sent.
     */
    getPostingsData(silent) {
        const self = this;

        if (!self.property_selected) {
            self.report_data = null;
            if (!silent) {
                self.SSAlertService.danger("Please select a Project and click apply to retrieve filtered records.");
            }
            return false;
        }

        if (!self.filter || !self.filter.posting_status) {
            self.SSAlertService.danger("Please select Posting Status to retrieve filtered instruments.");
            return false;
        }

        self.report_data = null;
        // WEB-4570: the rows being marked belong to this Project, even if the dropdown changes later.
        self.listed_property_selected = self.property_selected;

        let types = [];
        if (self.paymentTypes && self.paymentTypes.length){
            types = self.paymentTypes.map(p=> {
                if (p.allowed) return p.id;
            })
        }

        let url = "sec/developer/properties/reports/posting";
        let params = {
            offset: self.offset,
            limit: self.limit,
            count: true,
            property: self.property_selected,
            from_date: self.property_selected_from_date,
            to_date: self.property_selected_to_date,
            date: self.filter.date_type,
            posting_status: self.filter ? self.filter.posting_status : null,
        };
        Object.assign(params, self._paymentTypeParams()); // WEB-4706
        if (self.filter.searchFilter === self.CATEGORY_PAYMENT) {
            url = "sec/developer/properties/reports/payment-posting";
        } else {
            params.types = JSON.stringify(types);
        }

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self._displayPostingError(response);
                return;
            }
            self.report_data = response.data.report_data;
            self.property_list = response.data.properties;

            if (self.filter && self.filter.searchFilter === self.CATEGORY_INSTRUMENT){
                // Set can_mark_for_posting flag for instruments
                self.report_data.forEach(i => {
                    i.can_mark_for_posting = true; // set the default can_mark_for_posting value for instruments

                    /** WEB-4703: a refund's instrument is not held back behind its payment's posting
                     * status — same as the Digital Bookings app's isInstrumentPostingAllow() (WEB-3274).
                     * A normal refund's payment is never posted and its Mark Reviewed / Post buttons are
                     * gone from Sale Details, so without this its instrument could never be ticked here.
                     * The app exempts every refund, Aborted-sale ones included, and this row carries no
                     * clause id to tell them apart, so Web follows the same rule. `payment_clause_type` is
                     * the payment's payments.type column (loose compare: it may arrive as a string). */
                    if (i.payment_clause_type == self.PAYMENT_TYPE_20_REFUND) { return; }

                    if (self.filter.posting_status == self.INSTRUMENT_POSTING_STATUS_PENDING){
                        /** If posting status is pending, then only instruments
                         * with payment's posting status reviewed or above can be allowed to update posting status */
                        if (!i.payment_posting_status || (i.payment_posting_status != self.INSTRUMENT_POSTING_STATUS_REVIEWED
                            && i.payment_posting_status != self.INSTRUMENT_POSTING_STATUS_MARKED_FOR_POSTING
                            && i.payment_posting_status != self.INSTRUMENT_POSTING_STATUS_POSTED)){
                            i.can_mark_for_posting = false;
                        }
                    } else {
                        /** If posting status is reviewed, then only instruments with payment's posting status
                         * marked for posting or above can be allowed to update the posting status */
                        if (!i.payment_posting_status || (i.payment_posting_status != self.INSTRUMENT_POSTING_STATUS_MARKED_FOR_POSTING
                            && i.payment_posting_status != self.INSTRUMENT_POSTING_STATUS_POSTED)){
                            i.can_mark_for_posting = false;
                        }
                    }
                })
            }

            var count = 0;
            $.each(self.property_list, function (key, value) {
                count++;
                if (key == "") delete self.property_list[key];
                if (count == 2) self.firstVal = key;
            });
            self.last_generated_date = response.data.last_date;
            self.property_selected = response.data.selected_property;
        });
    }

    /**
     * Show a listing error, naming a missing SAP posting setup instead of the generic 412.
     *
     * WEB-4410: the posting reports reject with 412 / 412001 and
     * `data.posting_category` when the project has no enabled default SAP (SFTP)
     * posting configuration. parseAndDisplayError() would only show
     * "Invalid Params! Please fill-in the valid information.", which gives the user
     * nothing to act on. Every other error still goes through parseAndDisplayError()
     * so the 401 logout / 403 side-effects are kept.
     *
     * @param {Error|Object} response Rejected SSHttpService response (see http.js makeErrorObject()).
     * @returns {void}
     */
    _displayPostingError(response) {
        const self = this;

        if (response && response.code == 412 && response.data && response.data.posting_category) {
            self.SSAlertService.danger(
                "SAP Posting not configured!",
                "This project has no default SAP posting configuration. Please contact your administrator to set it up."
            );
            return;
        }

        self.SSAlertService.parseAndDisplayError(response);
    }

    reset() {
        const self = this;

        let searchFilter = angular.copy(self.filter.searchFilter);
        self.filter = {}; // Filters object
        self.filter.searchFilter = searchFilter; // reset the search filter
        if (self.filter.searchFilter === self.CATEGORY_PAYMENT) {
            self.filter.date_type = "serving_date";
        } else if (self.filter.searchFilter === self.CATEGORY_INSTRUMENT) {
            self.filter.date_type = "receiving_date";
        }
        self.filter.posting_status = ""+self.INSTRUMENT_POSTING_STATUS_PENDING;
        self.property_selected = self.firstVal;
        self.property_selected_from_date = "";
        self.property_selected_to_date = "";
        if (self.paymentTypes && self.paymentTypes.length){
            self.paymentTypes.forEach(p => p.allowed = true);
        }

        self.$timeout(function () {
            $("select.dashboard-select").niceSelect("update");
            jQuery(".datepicker").datepicker({
                changeMonth: true,
                changeYear: true,
                yearRange: "1900:+0",
                dateFormat: "yy-mm-dd",
            });
        });
        self.getPostingsData(true); // WEB-4410: no alert if Reset leaves no Project selected
    }

    exportExcel() {
        const self = this;

        // WEB-4410: same Project requirement as getPostingsData(); the export opens in a
        // new tab, so a server-side 412 there would only show a raw JSON body.
        if (!self.property_selected) {
            self.SSAlertService.danger("Please select a Project to export.");
            return false;
        }

        let types = [];
        if (self.paymentTypes && self.paymentTypes.length){
            types = self.paymentTypes.map(p=> {
                if (p.allowed) return p.id;
            })
        }

        let url = "sec/developer/properties/reports/posting/export";
        let params = {
            offset: self.offset,
            limit: self.limit,
            count: true,
            property: self.property_selected,
            from_date: self.property_selected_from_date,
            to_date: self.property_selected_to_date,
            date: self.filter.date_type,
            posting_status: self.filter ? self.filter.posting_status : null,
        };
        // WEB-4706: the export now honours the Payment Type filter, so it matches the list.
        Object.assign(params, self._paymentTypeParams());
        if (self.filter.searchFilter === self.CATEGORY_PAYMENT) {
            url = "sec/developer/properties/reports/payment-posting/export";
        } else {
            params.types = JSON.stringify(types);
        }
        // WEB-3591: no api_token on the URL; the same-origin proxy attaches it
        // server-side. device_uuid now opens the query string.
        url += "?device_uuid=" + self.SSUtilService.localStorageUUID();

        Object.keys(params).forEach(k => {
            if (params[k]){
                url+="&"+k+"="+encodeURI(params[k]);
            }
        })
        url = self.SSHttpService.getApiURL(url);

        window.open(url, "_blank");
    }

    updatePostingStatus() {
        const self = this;

        if (!self.filter || !self.filter.posting_status) {
            self.SSAlertService.danger("Please select a Posting Status and click apply to filter instruments."); // improbable
            return false;
        }

        self.child = [];
        $("input[name='child[]']:checked").each(function () {
            if ($(this).val() !== "" && $(this).val() !== ",")
                self.child.push($(this).val());
            /* Updated postings retrieved after update
            var val = $(this).val();
            jQuery.each(self.report_data, function (i, e) {
                if (typeof e != "undefined" && e.instrument_id == val) {
                    self.report_data.splice(i, 1);
                }
            });*/
        });
        if (self.child.length <= 0) {
            self.SSAlertService.danger("Please select any/all record(s).");
            return false;
        }

        let updated_posting_status = null;
        let confirmation_message = null;
        self.posting_date_error = null;
        if (self.filter.posting_status == self.INSTRUMENT_POSTING_STATUS_PENDING) {
            confirmation_message = "Are you sure you want to Mark Reviewed?";
            updated_posting_status = self.INSTRUMENT_POSTING_STATUS_REVIEWED;

            let handleResponse = function (response) {
                self.SSAlertService.success("Posting status updated successfully.");
                self.getPostingsData();
            }

            self.SSConfirmationService.getConfirmed(
                'Confirm!',
                confirmation_message,
                self.SSConfirmationService.TYPE_DEFAULT,
                function () {
                    self._updatePostingStatusReviewed(self.child, updated_posting_status, handleResponse);
                }
            );
        } else if (self.filter.posting_status == self.INSTRUMENT_POSTING_STATUS_REVIEWED) {
            self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function () {
                let date = new Date();
                self.posting_status = self.INSTRUMENT_POSTING_STATUS_MARKED_FOR_POSTING;
                self.posting_api_error = null; // Reset previous error when opening the modal
                // Always set the current date for posting date in case of bulk
                self.posting_date =  (date.getDate().toString().padStart(2, '0') + '/' + (date.getMonth()+1).toString().padStart(2, '0') + '/' +date.getFullYear());

                // WEB-4570: the earliest selectable date is the Financial Period Close
                // min_open_date (no bound when nothing is closed); future dates are never
                // allowed. The posting-date window itself is enforced server-side (WEB-3411).
                self._loadPostingMinOpenDate(self._listedPropertyId(), function (minDate) {
                    self.$timeout(function () {
                        jQuery('#posting_date').datepicker("destroy"); // Ensure old settings are removed
                        jQuery('#posting_date').datepicker({
                            changeMonth: true,
                            changeYear: true,
                            dateFormat: "dd/mm/yy",
                            minDate: minDate,
                            maxDate: new Date(),
                        });
                    });

                    $('#mark_posting_confirmation_modal').modal('show');
                });
            });
        }
    }

    /**
     * WEB-4570: Numeric id of the Project whose rows are listed. The Project dropdown
     * holds `named_id`, while posting-period-close filters on `property_id`.
     *
     * @returns {?number}
     */
    _listedPropertyId() {
        const self = this;

        let selected = self.listed_property_selected || self.property_selected;
        if (!selected) { return null; }
        let property = (self.allProperties || []).find(p => p.named_id == selected || p.id == selected);
        return property ? property.id : null;
    }

    /**
     * WEB-4570: Fetch the earliest open (not period-closed) posting date for a project.
     * Calls back with a local Date, or null when nothing is closed or the request fails —
     * the server still validates every posting date, so a failure only loosens the picker.
     *
     * @param {?number} propertyId
     * @param {function(?Date)} callback
     */
    _loadPostingMinOpenDate(propertyId, callback) {
        const self = this;

        if (!propertyId) { callback(null); return; }

        loading(true);
        self.SSHttpService.getAPIRequest('sec/developer/posting-period-close', {property_id: propertyId}).then(function (response) {
            loading(false);
            let periods = (response instanceof Error || !response || !response.data) ? null : response.data.posting_periods;
            let minOpenDate = periods && periods.length ? periods[0].min_open_date : null;
            callback(minOpenDate ? self.SSUtilService.parseDate(String(minOpenDate).substring(0, 10)) || null : null);
        });
    }

    _updatePostingStatusReviewed(ids, updated_posting_status, callback) {
        const self = this;

        if (!ids || !updated_posting_status) { return false; }
        let url = 'sec/developer/sales/payments/instruments/update-posting-status';
        let params = {
            category: self.filter.searchFilter,
            posting_status: updated_posting_status
        };
        if (self.filter.searchFilter === self.CATEGORY_PAYMENT) {
            params.payment_ids = ids;
        } else {
            params.instrument_ids = ids;
        }

        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            if (response instanceof Error) {
                loading(false);
                self.SSAlertService.parseAndDisplayError(response);
                return false;
            }

            if (callback) { callback(response); }
        });
    }

    updatePostingStatusPost() {
        const self = this;

        self.posting_date_error = null;
        self.posting_api_error = null;
        let ids = self.child;
        if (!ids || !self.posting_status) { return false; }

        // Check posting date is required.
        // WEB-3411: posting-window enforcement is server-side; the API rejects with subcode
        // 301040 if the date is outside the developer's configured SAP posting window. The
        // server's message is shown both via SSAlertService.parseAndDisplayError (global
        // toast) and inline below the modal buttons (posting_api_error) so the user sees
        // it without dismissing the modal.
        if (!self.posting_date) {
            self.posting_date_error = "Please select posting date.";
            return false;
        }

        let url = 'sec/developer/sales/payments/instruments/update-posting-status';
        let params = {
            category: self.filter.searchFilter,
            posting_status: self.posting_status,
            posting_date: self.posting_date
        };
        if (self.filter.searchFilter === self.CATEGORY_PAYMENT) {
            params.payment_ids = ids;
        } else {
            params.instrument_ids = ids;
        }

        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            if (response instanceof Error) {
                loading(false);
                // Show the server's message inline in the modal so the user sees it
                // without dismissing the dialog. parseAndDisplayError still fires for
                // the global toast / status-code-specific handling.
                self.posting_api_error = (response && response.data && response.data.message)
                    || (response && response.message)
                    || "Posting failed. Please try again or contact support.";
                self.SSAlertService.parseAndDisplayError(response);
                return false;
            }
            self.posting_api_error = null;
            $('#mark_posting_confirmation_modal').modal('hide');
            self.SSAlertService.success("Posting status updated successfully.");
            self.getPostingsData();
        });
    }

    getPaymentClauseName(code) {
        const self = this;

        if (!code || !self.serverConfig || !self.serverConfig.payment_types) { return "--" }

        let clause = self.serverConfig.payment_types.find(p => p.id === code);
        return  clause && clause.name ? clause.name : "--";
    }

    toggleSearchFilter(filter) {
        const self = this;

        if (!filter) return;

        self.filter.searchFilter = filter;
        if (self.filter.searchFilter === self.CATEGORY_PAYMENT) {
            self.filter.date_type = "serving_date";
        } else if (self.filter.searchFilter === self.CATEGORY_INSTRUMENT) {
            self.filter.date_type = "receiving_date";
        }

        // WEB-4706: the Interest Waiver option is Payments-tab only; clear it before it disappears.
        if (self.filter.searchFilter !== self.CATEGORY_PAYMENT
            && self.filter.clause_type === self.CLAUSE_TYPE_INTEREST_WAIVER) {
            self.filter.clause_type = null;
        }
        self._refreshPaymentTypeOptions();

        self.getPostingsData(true); // Apply filter after category change; silent when no Project (WEB-4410)
    }

    showPostingNotAllowedModal(entity_obj) {
        const self = this;

        self.posting_alert_msg = "Please update Invoice status first.";
        if (self.filter.searchFilter == self.CATEGORY_INSTRUMENT && entity_obj.can_mark_for_posting){
            if (entity_obj.instrument_type == self.INSTRUMENT_TYPE_CHEQUE) {
                if (!entity_obj.bank_in_date) {
                    self.posting_alert_msg = "Please enter Bank-In Date.";
                }
            } else if(!entity_obj.receiving_date) {
                self.posting_alert_msg = "Please enter Date Received.";
            }
        } else if (self.filter.searchFilter == self.CATEGORY_PAYMENT && !entity_obj.serving_date) {
            self.posting_alert_msg = "Please enter Notice Served Date.";
        }

        event.target.checked = false; // Uncheck checkbox
        $('#posting_status_update_not_allowed_modal').modal('show');
        return false;
    }

    getPaymentPlans(){
        const self = this;

        let url = 'sec/developer/payment-plans';
        let params = {
            include: "payment_plan_clauses"
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data
                && response.data.payment_plans
                && response.data.payment_plans.length > 0
            ) {
                self.paymentPlans = response.data.payment_plans;
                self.loadDefaultPaymentPlanClauses();
            }
        });
    }

    loadDefaultPaymentPlanClauses(){
        const self = this;

        if (!self.paymentPlans || !self.paymentPlans.length){
            console.warn("No Payment Plans found!");
            return;
        }

        let defaultPaymentPlan = self.paymentPlans.find(p => p.is_default && p.is_active);
        if (defaultPaymentPlan) { // If the default payment plan exists, set its clauses
            self.clauses = defaultPaymentPlan.payment_plan_clauses;
        } else if (self.paymentPlans.find(p => p.is_active)
            && self.paymentPlans.find(p => p.is_active).payment_plan_clauses) { // If no default payment plan exists, set clauses of first payment plan
            console.warn("Default payment plan not found, using first payment plan found as default");
            self.clauses = self.paymentPlans.find(p => p.is_active).payment_plan_clauses;
        }

        self.clauses = self.clauses.filter(item => item.payment_type !== null);
        self._refreshPaymentTypeOptions(); // WEB-4706

    }

    /**
     * WEB-4706: Rebuild the Payment Type dropdown options for the active tab.
     *
     * The project's payment-plan clauses, plus "Interest Waiver" on the Payments tab. A waiver
     * has no instrument (WEB-3719), so the Instruments tab never offers it. The array is
     * rebuilt rather than recomputed per digest, so ng-options sees a stable reference.
     *
     * @returns {void}
     */
    _refreshPaymentTypeOptions() {
        const self = this;

        let options = (self.clauses || []).slice();
        if (self.filter && self.filter.searchFilter === self.CATEGORY_PAYMENT) {
            options.push(self.interestWaiverOption);
        }
        self.paymentTypeOptions = options;
    }

    /**
     * WEB-4706: The Payment Type filter as posting-report query params.
     *
     * A clause option sends its `payment_type` as `clause_type`. The Interest Waiver option
     * sends `clause_type` = PAYMENT_TYPE_20_REFUND plus `refund_type` = PAYMENT_REFUND_TYPE_10_WAIVER,
     * which the API matches on the payment's own columns (a waiver has no clause). Without
     * `refund_type`, clause_type 20 on the Payments tab still means clause-bound Aborted refunds.
     *
     * @returns {{clause_type: (number|null), refund_type: (number|undefined)}}
     */
    _paymentTypeParams() {
        const self = this;

        let clauseType = self.filter ? self.filter.clause_type : null;
        if (clauseType === self.CLAUSE_TYPE_INTEREST_WAIVER) {
            return {
                clause_type: self.PAYMENT_TYPE_20_REFUND,
                refund_type: self.PAYMENT_REFUND_TYPE_10_WAIVER,
            };
        }
        return { clause_type: clauseType ? clauseType : null };
    }

    getPropertyCountry(propertyCode) {
        const self = this;

        if (!propertyCode || !self.allProperties || !self.allProperties.length) {
            return null;
        }

        let property = self.allProperties.find(p => p.named_id == propertyCode);
        return property? property.country : null;
    }
    /** WEB-3184 Allgreen - Marking for Posting - Bank-in Date is required - END **/
}

SapPostingsController.$inject = [
    "$window",
    "$http",
    "SSHttpService",
    "SSUtilService",
    "SSAlertService",
    "SSUserService",
    "SSConfigService",
    "SSConfirmationService",
    "OTPService",
    "$timeout",
];
app.controller("SapPostingsController", SapPostingsController);
